import React, { useState } from 'react'
import logo from 'image/logo_icon.png'
import { useNavigate } from 'react-router-dom'
import { request } from 'meinian-package/src/utils'
import { ossImg } from 'meinian-package/src/utils/image'
import InsCollMoreAction from './insCollMoreAction'
import CardInfo from './cardInfo'
import './insColl.less'

export default (props) => {
  const {
    columnWidth,
    coverImgUrl,
    name,
    id,
    ownerName,
    blogNum,
    topStatus,
    isQuickAccess,
    initWaterfall,
    userNum,
    isPro,
    hiddenSticky,
    isDataAnalysis,
    markerNum,
    loginUserInfo,
    cooperation,
    setData,
    fetchData,
    shareStatus,
    lastBlogList,
    onResize,
    maxHeight = 500,
  } = props
  const history = useNavigate()
  const [maskVisible, setMaskVisible] = useState(false)

  const jumpToDetail = () => {
    history(`/home/coll/detail/${id}?inspirationId=${id}&tab=${isDataAnalysis ? 4 : ''}`)
    request.track({ code: 6400003, type: `查看灵感集-${id}` })
  }

  const onSticky = async (_topStatus, e) => {
    e && e.stopPropagation()
    if (_topStatus) {
      await request.get('/ins/inspiration/remove-top', { params: { inspirationId: id } })
    } else {
      await request.get('/ins/inspiration/set-top', { params: { inspirationId: id } })
    }
    initWaterfall && initWaterfall()
  }

  const _onChange = (success, itemParams) => {
    if (success) {
      setData((data) => {
        const index = data.findIndex(item => item.id === itemParams.id)
        if (index !== -1) {
          // eslint-disable-next-line no-param-reassign
          data[index] = { ...data[index], ...itemParams }
        }
        return [...data]
      })
      fetchData()
      onResize?.()
    }
  }

  const _onDelete = (itemParams) => {
    if (itemParams.id) {
      setData((data) => {
        const index = data.findIndex(item => item.id === itemParams.id)
        data.splice(index, 1)
        return [...data]
      })
      fetchData()
      onResize?.()
    }
  }
  return <a
    className="meinian-waterfall-card-inscoll"
    onClick={(e) => { e.preventDefault(); jumpToDetail() }}
    style={{
      width: columnWidth,
      height: columnWidth + 80,
      maxHeight: maxHeight + 80
    }}
  >
    <div
      style={{ height: columnWidth }}
      className="cover-wrap"
      onMouseEnter={() => setMaskVisible(true)}
      onMouseLeave={() => setMaskVisible(false)}
    >
      {
        coverImgUrl || (lastBlogList && lastBlogList[0]) ? <div className="main-img" style={{ backgroundImage: `url(${ossImg(coverImgUrl || ((lastBlogList && lastBlogList.length) && lastBlogList[0].mainUrl), 600, 600)})` }} />
          : <div className="main-img-empty">
            <img style={{ objectFit: 'cover' }} src={logo} />
          </div>
      }
      <div className="ins-coll-mask" style={{ visibility: maskVisible ? 'visible' : 'hidden' }}>
        <div className="user-wrap">
          {cooperation ? <div className="info line-1" style={{ minWidth: 'fit-content' }}>
            {userNum ? <span style={{ marginRight: 8 }}>{userNum}人协作</span> : null}
            {markerNum ? <span>{markerNum}人审核</span> : null}
          </div> : <div className="info line-1" style={{ minWidth: 'fit-content' }}>私密</div>}
        </div>
        <div className="actions">
          { hiddenSticky ? null : <div className="button" onClick={(e) => { e.preventDefault(); onSticky(topStatus, e); request.track({ code: 6400008, type: `置顶灵感集-${id}-${topStatus}` }) }}>
            {topStatus ? '取消置顶' : '置顶'}
          </div> }
          <div className="meinian-space" />
          <div onClick={e => e.stopPropagation()}>
            <InsCollMoreAction
              loginUserInfo={loginUserInfo}
              isQuickAccess={isQuickAccess}
              shareStatus={shareStatus}
              id={id}
              name={name}
              blogNum={blogNum}
              onDelete={_onDelete}
              onChange={_onChange}
            />
          </div>
        </div>
      </div>
    </div>
    <CardInfo isPro={isPro} name={name} ownerName={ownerName} blogNum={blogNum} />
  </a>
}
